import BeneficiariesStore from '../stores/BeneficiariesStore';
import { decorate, observable, action, runInAction } from 'mobx';
import { ParentTableStore } from '@mq/voltron-parent';

export default class BeneficiariesTableStore extends ParentTableStore {
  constructor(args: Object = {}) {
    super(args);
    this.load(args);
  }

  // values
  items: Array<BeneficiariesStore> = [];
  count: number = 50;
  sort_by: string = 'state';

  // actions
  async hydrate() {
    this.loading = true;
    const result = await this.gqlQuery(
      `query externalAccounts($user_token: ID) {
        externalAccounts(user_token: $user_token) {
          count
          data {
            token
            alias
            account_number
            sort_code
            routing_number
            status
            created_time
            last_modified_time
          }
        }
      }`,
      { ...this.hydrateParams, user_token: this.cardholder_token }
    );

    runInAction(() => {
      const externalAccounts = this.extract(result, 'externalAccounts');
      this.processPaginationResponse(externalAccounts, BeneficiariesStore);
      this.loading = false;
    });
  }
}

decorate(BeneficiariesTableStore, {
  // values
  items: observable,
  count: observable,
  sort_by: observable,

  // actions
  hydrate: action.bound,
});
